module.exports = __webpack_public_path__ + "img/HTML5.9944520f.png";